module.exports = __webpack_public_path__ + "img/circle.da071c5c.svg";